import React from 'react';

export function PrizeDigits({ digits, size = 'md' }) {
  const value = digits || '';
  const boxes = value.split('');
  const sizeClass =
    size === 'lg'
      ? 'h-11 w-8 text-xl sm:h-14 sm:w-10 sm:text-2xl'
      : 'h-9 w-7 text-lg sm:h-10 sm:w-8 sm:text-xl';

  return (
    <div className="flex justify-center gap-1.5 sm:gap-2">
      {boxes.map((digit, index) => (
        <div
          key={`${digit}-${index}`}
          className={`flex items-center justify-center rounded-lg border-2 border-brand-gold bg-white font-mono font-bold text-brand-red ${sizeClass}`}
        >
          {digit}
        </div>
      ))}
    </div>
  );
}
